// Formatting file tags for search results
import { getTranslation, getFilesStore, escapeHtml } from '../helpers.js';

/**
 * Format file tags (language, material type, format)
 * @param {Object} item - Search result item
 * @param {string} linkKey - File link key
 * @returns {string} HTML string with tags
 */
export function formatFileTags(item, linkKey) {
    const tags = [];
    
    // Try to get file from filesStore by path
    let fileData = null;
    try {
        const store = getFilesStore();
        if (store && store.length) {
            const normalizedLink = linkKey.replace(/^\/+/, '').toLowerCase();
            fileData = store.find(f => {
                const full = `${(f.p || '').replace(/^\/+|\/+$/g, '')}${f.p ? '/' : ''}${f.n || ''}`.replace(/^\/+/, '').toLowerCase();
                return full === normalizedLink;
            });
        }
    } catch(_) {}
    
    // Language tag (L) - from file data or search result
    let langValue = null;
    if (fileData && fileData.L) {
        langValue = fileData.L;
    } else if (item.language) {
        const langMap = {
            'ENGLISH': 'EN', 'RUSSIAN': 'RU', 'GERMAN': 'DE', 'FRENCH': 'FR', 'SPANISH': 'ES', 'CHINESE': 'CN'
        };
        langValue = langMap[item.language.toUpperCase()] || item.language.toUpperCase();
    }
    
    if (langValue) {
        const langLabel = getTranslation(langValue, langValue);
        tags.push(`<span class="fulltext-tag fulltext-tag--language" title="Language">${escapeHtml(langLabel)}</span>`);
    }
    
    // Material type tag (M) - from file data or search result
    let materialValue = null;
    if (fileData && fileData.M) {
        materialValue = fileData.M;
    } else if (item.material_type) {
        const materialMap = {
            'Books': 'Bk', 'Courses': 'Co', 'Dictionaries': 'Di', 'Lectures': 'Le',
            'TECH': 'Bs', 'ADMIN': 'PL', 'Other': 'Ot', 'Volumes': 'Ot', 'Journals': 'Ot'
        };
        materialValue = materialMap[item.material_type] || item.material_type;
    }
    
    if (materialValue) {
        const materialLabel = getTranslation(materialValue, materialValue);
        tags.push(`<span class="fulltext-tag fulltext-tag--material" title="Material">${escapeHtml(materialLabel)}</span>`);
    }
    
    // Format tag (F) - from file data only
    if (fileData && fileData.F) {
        const formatLabel = getTranslation(fileData.F, fileData.F);
        tags.push(`<span class="fulltext-tag fulltext-tag--format" title="Format">${escapeHtml(formatLabel)}</span>`);
    }
    
    return tags.length > 0 ? tags.join('') : '';
}
